import type { DictionaryEntry, TrieNode } from "./types";

export function createTrieNode(): TrieNode {
  return {
    children: new Map(),
    entries: [],
    isEndOfWord: false,
  };
}

export function buildTrie(entries: DictionaryEntry[]): TrieNode {
  const root = createTrieNode();

  for (const entry of entries) {
    let node = root;

    // Index by traditional characters
    for (const char of entry.traditional) {
      if (!node.children.has(char)) {
        node.children.set(char, createTrieNode());
      }
      node = node.children.get(char)!;
    }

    node.isEndOfWord = true;
    node.entries.push(entry);
  }

  return root;
}

export function findLongestMatch(
  input: string,
  startIndex: number,
  trie: TrieNode
): { length: number; entries: DictionaryEntry[] } | null {
  let node = trie;
  let lastMatch: { length: number; entries: DictionaryEntry[] } | null = null;
  let i = startIndex;

  while (i < input.length && node.children.has(input[i])) {
    node = node.children.get(input[i])!;
    i++;

    if (node.isEndOfWord) {
      lastMatch = { length: i - startIndex, entries: node.entries };
    }
  }

  return lastMatch;
}
